import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import { Table } from '../../../components/Table';
import styles from '../css/DOHGuidelineViewMore.module.css';

const DOHGuidelineViewMore = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const pageTitle = (state && state.title) ? state.title : 'Family Planning';

  const columns = useMemo(
    () => [
      { header: 'Category', accessor: 'category' },
      { header: 'ICD Code(s)', accessor: 'icd' },
      { header: 'Medication Name', accessor: 'medication' },
      { header: 'Formulation & Strength', accessor: 'formulation' },
      { header: 'Frequency/Dosage', accessor: 'frequency' },
      { header: 'Notes', accessor: 'notes' },
    ],
    []
  );

  const data = useMemo(
    () => [
      {
        category: 'Injection Contraceptive',
        icd: 'Z30.0 / Z30.4',
        medication: 'Medroxyprogesterone (long-acting)',
        formulation: 'IM injections, 150mg',
        frequency: 'Every 12 weeks (3 months)',
        notes: 'Injection technique is part of PCDT training. Routine administration.',
      },
      {
        category: 'Oral Contraceptive (Mono)',
        icd: 'Z30.3 / Z30.4',
        medication: 'Levonorgestrel',
        formulation: 'Oral, 30mcg',
        frequency: 'Daily (d)',
        notes: 'Monophasic preparation',
      },
      {
        category: 'Oral Contraceptive (Mono)',
        icd: 'Z30.3 / Z30.4',
        medication: 'Ethinylestradiol / Levonorgestrel',
        formulation: 'Oral, 30mcg / 150mcg',
        frequency: 'Daily (d)',
        notes: 'Monophasic preparation',
      },
      {
        category: 'Oral Contraceptive (Triphasic)',
        icd: 'Z30.3 / Z30.4',
        medication: 'Ethinylestradiol / Levonorgestrel',
        formulation: 'Oral, 30mcg / 150mcg',
        frequency: 'Daily (d)',
        notes: 'Triphasic preparation',
      },
    ],
    []
  );

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <main className={styles.container}>
        <h1 className={styles.title}>{pageTitle}</h1>

        <div className={styles.tableCard}>
          <Table columns={columns} data={data} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DOHGuidelineViewMore;
